<h1 mat-dialog-title *ngIf="!isLoading" xmlns="http://www.w3.org/1999/html" class="event-edit-details__title">Edit Event Details</h1>
<div id="spinnerContainer" *ngIf="isLoading">
  <mat-dialog-content>
    <mat-spinner id="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
  </mat-dialog-content>
</div>
<div *ngIf="!isLoading">
  <mat-dialog-content [formGroup]="formGroup">
    <fieldset class="event-edit-details__form-section">
      <legend class="event-edit-details__form-section-title">Date and Time</legend>
      <mat-error class="event-edit-details__form_field_padding" *ngIf="showDateError()">Start time cannot be after end time</mat-error>
      <div class="event-edit-details__horizontal-fields">
        <mat-form-field>
          <input matInput
                 name="startDate"
                 formControlName="startDate"
                 [matDatepicker]="startDate"
                 [min]="startDateMin"
                 placeholder="Pick Start Date *"
                 (dateChange)="eventDateChange('input', $event)"/>
          <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
          <mat-datepicker #startDate></mat-datepicker>

        </mat-form-field>

        <div class="event-edit-details__time-header">Select Start Time: </div>
        <mat-form-field>
          <mat-select placeholder="Hour" formControlName="startHour">
            <mat-option value="{{hour}}" *ngFor="let hour of eventHours">{{hour}}</mat-option>
          </mat-select>
        </mat-form-field>
        <div class="event-edit-details__time-colon">:</div>
        <mat-form-field>
          <mat-select placeholder="Minute" formControlName="startMin">
            <mat-option value="{{min}}" *ngFor="let min of eventMinutes">{{min}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-select placeholder="AM/PM" formControlName="startAMPM">
            <mat-option value="{{ampm}}" *ngFor="let ampm of eventAMPM">{{ampm}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="event-edit-details__horizontal-fields">
        <mat-form-field>
          <input
            name="endDate"
            formControlName="endDate"
            matInput [matDatepicker]="endPicker"
            [min]="endDateMin"
            placeholder="Pick End Date *"
            (dateChange)="eventDateChange('input', $event)"/>
          <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
        </mat-form-field>

        <div class="event-edit-details__time-header">Select End Time:</div>
        <mat-form-field>
          <mat-select placeholder="Hour" formControlName="endHour">
            <mat-option value="{{hour}}" *ngFor="let hour of eventHours">{{hour}}</mat-option>
          </mat-select>
        </mat-form-field>
        <div class="event-edit-details__time-colon">:</div>
        <mat-form-field>
          <mat-select placeholder="Minute" formControlName="endMin">
            <mat-option value="{{min}}" *ngFor="let min of eventMinutes">{{min}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-select placeholder="AM/PM" formControlName="endAMPM">
            <mat-option value="{{ampm}}" *ngFor="let ampm of eventAMPM">{{ampm}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <mat-form-field class="event-edit-details__formItemSmallText">
        <mat-label>Time Zone *</mat-label>
        <mat-select formControlName="timezone">
          <mat-option value="{{tz}}" *ngFor="let tz of timeZones">{{tz}}</mat-option>
        </mat-select>
      </mat-form-field>
    </fieldset>
    <fieldset class="event-edit-details__form-section">
      <legend class="event-edit-details__form-section-title">Website/Registration</legend>
        <mat-form-field id="websiteRegistrationField" class="event-edit-details__formItem">
          <input matInput
                 placeholder="Event Registration Link"
                 formControlName="webinarRegistrationLink">
        </mat-form-field>
        <mat-form-field id="websiteInformationField" class="event-edit-details__formItem">
          <input matInput
                 placeholder="Event Info Website Link"
                 formControlName="informationWebsite">
        </mat-form-field>
        <mat-form-field id="websiteCustomLabelField" class="event-edit-details__formItem">
          <input matInput
                 placeholder="Event Website Custom Label"
                 formControlName="websiteCustomLabel">
        </mat-form-field>
    </fieldset>
    <fieldset class="event-edit-details__form-section">
      <legend class="event-edit-details__form-section-title">Basic Event Settings</legend>
        <mat-form-field class="event-edit-details__formItem">
            <mat-label>Event Type *</mat-label>
            <mat-select formControlName="type">
              <mat-option value="{{eventType}}" *ngFor="let eventType of eventTypes">{{eventType}}</mat-option>
            </mat-select>
          </mat-form-field>
          <!-- <mat-form-field class="formItem">
            <mat-label>Event Format *</mat-label>
            <mat-select formControlName="format">
              <mat-option value="In-Person">In-Person</mat-option>
              <mat-option value="Online">Online</mat-option>
              <mat-option value="Both">Both</mat-option>
            </mat-select>
          </mat-form-field> -->
        <mat-form-field id="costField" class="event-edit-details__formItem">
          <input matInput
                 placeholder="Event Cost"
                 formControlName="cost">
        </mat-form-field>
    </fieldset>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button type="submit" [disabled]="!formGroup.valid" class="submit-button mat-raised-button" (click)="save()">
      Save
    </button>
    <button id="cancelButton" class="mat-raised-button" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
